// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".basic .col[data-v-db76b81c]:not(.col-12){flex:0 0 20%;max-width:20%}@media(max-width:991px){.basic .col[data-v-db76b81c]:not(.col-12){flex:0 0 50%;max-width:50%}}", ""]);
// Exports
module.exports = exports;
